import { motion } from 'framer-motion';

export default function Courses() {
    const courses = [
        {
            name: "Chemical Reaction Engineering-II",
            level: "Undergraduate",
            icon: "book"
        },
        {
            name: "Industrial Pollution Abatement",
            level: "Undergraduate",
            icon: "nature"
        },
        {
            name: "Mechanical Operations",
            level: "Undergraduate",
            icon: "settings"
        },
        {
            name: "Advanced Separation Processes",
            level: "Postgraduate",
            icon: "layers"
        },
        {
            name: "Introduction to Water Pollution",
            level: "Elective",
            icon: "water_drop"
        },
        {
            name: "Natural Gas Engineering",
            level: "Elective",
            icon: "local_fire_department"
        },
        {
            name: "Industrial and Engineering Chemistry",
            level: "Undergraduate",
            icon: "science"
        }
    ];

    return (
        <section id="courses" className="py-8 bg-background-light dark:bg-background-dark w-full">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="text-2xl font-display font-bold text-center text-gray-900 dark:text-white mb-2">Academic Courses</h2>
                    <p className="text-center text-gray-500 dark:text-gray-400 text-sm mb-10">Courses offered at Shiv Nadar University</p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {courses.map((course, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                            className="bg-white dark:bg-surface-dark p-4 rounded-lg border border-gray-200 dark:border-gray-700 flex justify-between items-center hover:shadow-md transition-shadow duration-300"
                        >
                            <div>
                                <h4 className="font-bold text-gray-800 dark:text-gray-200 text-sm">{course.name}</h4>
                                <span className="text-xs text-gray-500 dark:text-gray-400">{course.level}</span>
                            </div>
                            <span className="material-icons text-gray-300 dark:text-gray-600">{course.icon}</span>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}